import {NativeModules} from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import cookie from 'react-cookies';
import isEmpty from 'lodash/isEmpty';
import railsConfig from "../../Mobile-mmt-react-native/apps/rails/src/RailsConfig";
import { userServiceHeaders as userDetailsHeaders, userDetailsBody} from '../../Mobile-mmt-react-native/packages/legacy-commons/Common/Components/GSTIN/Helpers/utils';
import { getUserInfoPIIClient } from 'MMT-UI/getPIIData/client';

const _isUserLoggedIn = () => {
  const mmtAuth = window.location.href.includes('alliances.makemytrip') ? cookie.load('mmt-auth-hdfc_sb') : cookie.load('mmt-auth');
  console.log('mmtAuth', mmtAuth)
  return Promise.resolve(!isEmpty(mmtAuth));
};

const _getUserDetails = async () => {
try {
    const mmtAuth = await _getMmtAuth();
    if(!mmtAuth){
      throw new Error("User not logged in");
    }
    const userDetailsStr = await getUserInfoPIIClient();
    if(userDetailsStr){
      return userDetailsStr;
    }
    const response = await fetch(`${railsConfig.fetchFullUserDetailsURL}?mmt-auth=${mmtAuth}`, {
      method: 'POST'
    });
    const data = await response.json();
    let userDetails = _parseUserDetails(data, mmtAuth);
    return userDetails
  } catch (error) {
    return {};
  }
}

const _parseUserDetails = (userDetails, mmtAuth) => {
  const {
    result: {
      extendedUser: {
        associatedTravellers,
        profileType,
        primaryEmailId,
        personalDetails,
        profileId,
        contactDetails,
        uuid,
        loginInfoList
      }
    }
  } = userDetails;

  const {
    gender,
    name: {
      firstName,
      lastName,
    }
  } = personalDetails

  let mobileDetails =  loginInfoList.find(element => element.loginType === 'MOBILE');
  let emailDetails =  loginInfoList.find(element => element.loginType === 'EMAIL');
  let mobileNumber = null;
  let countryCode = null;
  let email = null;

  if(mobileDetails && mobileDetails.loginId && mobileDetails.loginId.length >= 10)
  {
    mobileNumber = mobileDetails.loginId.substr(mobileDetails.loginId.length - 10);
    countryCode = mobileDetails.loginId.substr(0,mobileDetails.loginId.length - 10);
  }


  if (mobileNumber === null) {
    let mobile = contactDetails.find(detail => detail.category === "MOBILE");
    if(mobile && mobile.info) {
      mobileNumber = mobile.info.substr(mobileDetails.loginId.length - 10);
      countryCode = mobile.info.substr(0,mobileDetails.loginId.length - 10);
    }
  }

  if(emailDetails && emailDetails.loginType === 'EMAIL') {
    email = emailDetails.loginId;
  }

  if(!email) {
    email = primaryEmailId;
  }
  return {
    firstName,
    lastName,
    profileType,
    mmtAuth,
    gender: gender === "NS" ? undefined : gender,
    email,
    mobile: {mobileNumber,
      countryCode
    }, uuid,
    travelers: associatedTravellers,
  }
};


const _getMmtAuth = async () => {
  const mmtAuth = window.location.href.includes('alliances.makemytrip') ? cookie.load('mmt-auth-hdfc_sb') : cookie.load('mmt-auth');
  if (isEmpty(mmtAuth)) {
    return Promise.reject(new Error('User not logged in'));
  }
  return Promise.resolve(mmtAuth);
};


const _showGSTNWidget = async () => {
  const isLoggedIn = await _isUserLoggedIn();

  if(!isLoggedIn) return true;

try {
    const options = {
      headers: await userDetailsHeaders(),
      body: JSON.stringify(userDetailsBody()),
      method: 'POST',
    }
  
    let res = await fetch(`${railsConfig.fetchUserDetailsURL}`, options);
    res = await res.json();
    
    const statePresent = getAddressinformation(res);
  
    if(statePresent.length > 0) return false;
  } catch (error) {
    return false;
  }

  return true;
}

const getAddressinformation = (userDetails) => {
  const {
    result: {
      extendedUser: {
        addressDetails,
        profileType,
      }
    }
  } = userDetails;
  
  const statePresent = addressDetails?.filter(address => {
    return address.state !== null;
  });

  return statePresent;
}

NativeModules.UserSessionModule = {
  isUserLoggedIn: _isUserLoggedIn,
  getUserDetails: _getUserDetails,
  getMmtAuth: _getMmtAuth,
  showGSTNWidget: _showGSTNWidget,
};
